import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';

import { Column } from '../Layout';
import { GlImage } from '../Image';

export const ImageColumn = styled(Column)<{
  imageFirst: boolean;
  color: string;
}>`
  overflow: hidden;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.m};
  max-height: 85vw;
  background-color: ${({ color }) => `#${color}`};

  ${mediaQueries.tablet} {
    background-color: transparent;
    margin-bottom: 0;
  }

  ${mediaQueries.desktop} {
    padding-left: ${({ theme, imageFirst }) => !imageFirst && theme.spacing.xl};
    margin-right: -${({ theme, imageFirst }) => !imageFirst && theme.spacing.xl};
    padding-right: ${({ theme, imageFirst }) => imageFirst && theme.spacing.xl};
    margin-left: -${({ theme, imageFirst }) => imageFirst && theme.spacing.xl};
  }
`;

export const StyledImage = styled(GlImage)`
  display: block;
  max-width: 100%;
  flex-shrink: 0;
`;
